import invert from 'lodash/invert';
import vanityUrlRedirects from '../../../data/vanityUrlRedirects.json';

export default invert(vanityUrlRedirects.guideIdsToPathnames);
